import { daysUntilBirthday } from '../../shared/helpers/map-congregacion-row';

const MESES = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
];

const DIAS_AVISO = 20;

export interface ProximoCumple {
  fecha: string;
  aviso: string | null;
}

function parseNacimiento(nacimiento: string): Date | null {
  const isoDay = /^(\d{4})-(\d{2})-(\d{2})/.exec(nacimiento.trim());
  if (isoDay) {
    return new Date(Number(isoDay[1]), Number(isoDay[2]) - 1, Number(isoDay[3]));
  }
  const parsed = new Date(nacimiento);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function avisoCumple(dias: number): string | null {
  if (dias >= DIAS_AVISO) {
    return null;
  }
  if (dias === 0) {
    return 'Hoy';
  }
  if (dias === 1) {
    return 'Falta 1 día';
  }
  return `Faltan ${dias} días`;
}

/** Día y mes del próximo cumpleaños. El aviso aparece si faltan menos de 20 días. */
export function proximoCumple(
  nacimiento: string | null | undefined,
  hoy: Date = new Date(),
): ProximoCumple | null {
  if (!nacimiento) {
    return null;
  }
  const birth = parseNacimiento(nacimiento);
  const dias = daysUntilBirthday(nacimiento, hoy);
  if (!birth || dias === null) {
    return null;
  }
  return {
    fecha: `${birth.getDate()} de ${MESES[birth.getMonth()]}`,
    aviso: avisoCumple(dias),
  };
}
